<template>
    <convenio-detalhar
        :dataServicos="obterDataServicos()"
        rotaListagem="Gescon_Convenios_Fornecedor"
        :temAcessoPrestacaoMensal="$temAcessoView('GESCON-FORN-CONV-02')"
        :permiteCadastrarPrestacaoMensal="$temAcessoView('GESCON-FORN-CONV-03')"
        :permiteExcluirJustificarPrestacaoMensal="$temAcessoView('GESCON-FORN-CONV-04')"
        :permiteEnviarPrestacaoParaAnalise="$temAcessoView('GESCON-FORN-CONV-12')"
        :temAcessoPrestacaoFinal="$temAcessoView('GESCON-FORN-CONV-06')"
        :permiteCadastrarPrestacaoFinal="$temAcessoView('GESCON-FORN-CONV-07')"
        :permiteExcluirPrestacaoFinal="$temAcessoView('GESCON-FORN-CONV-08')"
        :permiteAtualizarPrestacaoFinal="$temAcessoView('GESCON-FORN-CONV-08')"
        :permiteAcessarDocumentos="$temAcessoView('GESCON-FORN-CONV-09')"
        :permiteCadastrarDocumentos="$temAcessoView('GESCON-FORN-CONV-10')"
        :permiteExcluirDocumentos="$temAcessoView('GESCON-FORN-CONV-11')"
        :temAcessoEventos="$temAcessoView('GESCON-FORN-CONV-EVENTO-00')"
        :permiteInserirAtualizarEventos="$temAcessoView('GESCON-FORN-CONV-EVENTO-01')"
        :permiteCancelarEventos="$temAcessoView('GESCON-FORN-CONV-EVENTO-02')"
        :temAcessoDocumentosEvento="$temAcessoView('GESCON-FORN-CONV-EVENTO-03')"
        :temAcessoMetas="$temAcessoView('GESCON-FORN-CONV-META-00')"
        :permiteInserirMetas="$temAcessoView('GESCON-FORN-CONV-META-01')"
        :permiteCancelarMetas="$temAcessoView('GESCON-FORN-CONV-META-02')"
        :temAcessoAcoesPlanoTrabalho="$temAcessoView('GESCON-FORN-CONV-PLANO-00')"
        :permiteInserirAtualizarAcoesPlanoTrabalho="$temAcessoView('GESCON-FORN-CONV-PLANO-01')"
        :permiteCancelarAcoesPlanoTrabalho="$temAcessoView('GESCON-FORN-CONV-PLANO-02')"
        :permiteInserirCancelarDocumentosEvento="$temAcessoView('GESCON-FORN-CONV-EVENTO-04')"

        :temAcessoLicitacoes="$temAcessoView('GESCON-FORN-CONV-LIC-00')"
        :permiteInserirLicitacao="$temAcessoView('GESCON-FORN-CONV-LIC-01')"
        :permiteAtualizarLicitacao="$temAcessoView('GESCON-FORN-CONV-LIC-02')"
        :permiteExcluirLicitacao="$temAcessoView('GESCON-FORN-CONV-LIC-03')"

        :temAcessoDocumentosLicitacoes="$temAcessoView('GESCON-FORN-CONV-DOC-LIC-00')"


    ></convenio-detalhar>
</template>

<script>
import ConvenioDetalhar from '../componentes/detalhes/ConvenioDetalhes'
import ConveniosServicos from './ConvenioServicos'

export default {
    components: {
        ConvenioDetalhar
    },

    methods: {
        obterDataServicos() {
            return ConveniosServicos
        }
    }
}
</script>
